// extracted by mini-css-extract-plugin
export default {"result":"styles_result__tWL+c","wrapper":"styles_wrapper__bEK+s","message":"styles_message__iNIPJ","loaderContainer":"styles_loaderContainer__LhebT"};